export const SUCCESS_COLOR = '#91dfd2';
export const WARNING_COLOR = '#f4d44d';
export const ERROR_COLOR = '#f45060';
